<template>
  <v-container class="overflow-x-hidden overflow-y-auto mt-0 pt-0"
    :style="`height: ${filteredItems.length > 0 ? Math.min(18 + filteredItems.length, 23) : 10}rem;`">
    <v-row>
      <v-col cols="12" md="2">
        <v-card outlined class="pa-4">
          <v-btn outlined class="d-flex justify-center align-center full-width text-capitalize "
            v-on:click="addNewEnvVar">
            <v-icon left> mdi-plus </v-icon>
            {{ type === 'env' ? 'Environment' : 'Engine Argument' }}
          </v-btn>
        </v-card>
      </v-col>
      <v-col cols="12" md="10">
        <v-card outlined>
          <v-card-title class="d-flex justify-end ma-0 pa-0">
            <v-col cols="auto">
              <v-text-field outlined dense v-model="search" density="compact" label="Search"
                prepend-inner-icon="mdi-magnify" variant="outlined" hide-details />
            </v-col>
          </v-card-title>
          <v-card-text>
            <v-data-table elevation="0" :hide-default-footer="true" :headers="filteredHeaders" :items="filteredItems"
              item-value="option" v-if="filteredItems.length > 0">
              <template v-slot:item.option="{ item, index }">
                <v-text-field outlined dense v-model="item.option" persistent-hint hide-details
                  @input="change(item, index, 'option')" />
              </template>
              <template v-slot:item.type="{ item, index }">
                <v-select v-if="type==='arg'" v-model="item.type" :items="types" outlined dense
                   persistent-hint hide-details @update:modelValue="change(item, index, 'type')"
                  hint="Select a value type" />
              </template>
              <template v-slot:item.value="{ item, index }">
                <v-combobox v-if="item.type === 'multi' && type === 'arg'" v-model="item.allowed_values" outlined dense
                   multiple persistent-hint hide-details deletable-chips small-chips chips
                  hint="Press enter to add multiple values" @update:modelValue="setallowed_values(item, index, 'value')" />
                <v-text-field v-else-if="item.value==='text'" outlined dense v-model="item.value"  persistent-hint hide-details
                  @input="change(item, index, 'value')" />
                  <v-text-field v-else outlined dense v-model="item.value"  persistent-hint hide-details :disabled="item.type==='none'"
                  @input="change(item, index, 'value')" />
              </template>
              <template v-slot:item.description="{ item, index }">
                <v-text-field outlined dense v-model="item.description"  persistent-hint hide-details
                  @input="change(item, index, 'desc')" />
              </template>
              <template v-slot:item.action="{ item, index }">
               <v-row>
                <v-col class="auto d-flex justify-center align-center">
                  <v-checkbox class="ma-0" v-if="type === 'env'" v-model="item.isToken" label="Token" @click="onTokenChange(item, index)" hide-details />
                </v-col>
                <v-col class="auto">
                  <v-btn icon v-on:click="deleteRow(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                </v-col>
               </v-row>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from 'lodash'
export default {
  data () {
    return {
      rules: [(v) => !!v || 'Field is required'],
      headers: [
        { text: 'Key', value: 'option' },
        { text: 'Value Type', value: 'type', sortable: false },
        { text: 'Value', value: 'value', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Action', value: 'action', sortable: false }
      ],
      search: '',
      types: ['text', 'multi', 'none']
    }
  },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    itemProps: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'env'
    }
  },
  computed: {
    filteredItems () {
      return this.itemProps.filter(item =>
      item.option?.toLowerCase().includes(this.search.toLowerCase()) ||
      item.description?.toLowerCase().includes(this.search.toLowerCase()) ||
      item.value?.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    filteredHeaders () {
      // If type is 'arg', show the 'Value Type' column, else remove it.
      return this.headers.filter(header => {
        if (header.value === 'type' && this.type !== 'arg') {
          return false
        }
        return true
      })
    }
  },

  methods: {
    deleteRow (index) {
      this.itemProps.splice(index, 1)
    },
    addNewEnvVar () {
      this.itemProps.push({
        option: '',
        value: '',
        description: '',
        type: 'text',
        allowed_values: [],
        isToken: false
      })
    },
    change (item, index, type) {
      switch (type) {
        case 'option':
          this.itemProps[index].option = item.option
          break
        case 'value':
          this.itemProps[index].value = item.value
          break
        case 'desc':
          this.itemProps[index].description = item.description
          break
        case 'type':
          this.itemProps[index].type = item.type
          break
      }
    },
    setallowed_values (item, index) {
      this.itemProps[index].allowed_values = item.value
    },
    onTokenChange (item, index) {
      this.itemProps[index].isToken = item.isToken
    }
  },
  watch: {
    dialog: {
      handler: function (newVal) {
        this.items = []
      }
    },
    itemProps: {
      handler (newVal) {
        this.items = [...newVal]
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style>
.full-width {
  width: 100%;
}
</style>
